import request from '@/router/axios'

export function gameAll (params) {
  return request({
    url: '/api.php/Ajax/game_all',
    method: 'post',
    data: params
  })
}
/**
 * 初始化化数据
 * @returns
 */
export function getInitData (id) {
  return request({
    url: '/api.php/Ajax/getInitData',
    method: 'post',
    data: {id}
  })
}

/**
 * 提交表单
 * @returns
 */
export function formMessage (data) {
  return request({
    url: '/api.php/Ajax/form_message',
    method: 'post',
    data
  })
}
